"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SegmentControl = void 0;
var lodash_noop_1 = __importDefault(require("lodash.noop"));
var react_1 = __importStar(require("react"));
var Box_1 = require("./Box");
var HStack_1 = require("./HStack");
var typography_1 = require("./typography");
var ChildrenPositionContext = react_1.default.createContext({ first: false, last: false });
var SegmentControlContext = react_1.default.createContext({
    onChange: lodash_noop_1.default,
    currentValue: undefined,
});
function SegmentControl(_a) {
    var children = _a.children, value = _a.value, onChange = _a.onChange;
    var childrenCount = react_1.default.Children.count(children);
    // Warning! This cast is not entirely safe since we can't guarantee that both
    // SegmentControl and SegmentControl.Item have the same `Value` type.
    // FIXME: consider making both of these components be accesible via hook that would bind those
    // two types together.
    var changeHandler = function (newValue) { return onChange(newValue); };
    return (react_1.default.createElement(SegmentControlContext.Provider, { value: { currentValue: value, onChange: changeHandler } },
        react_1.default.createElement(HStack_1.HStack, { space: '$1px' }, react_1.default.Children.map(children, function (child, index) { return (react_1.default.createElement(ChildrenPositionContext.Provider, { value: { first: index === 0, last: index === childrenCount - 1 } }, child)); }))));
}
exports.SegmentControl = SegmentControl;
function SegmentItem(_a) {
    var children = _a.children, value = _a.value;
    var _b = react_1.useContext(SegmentControlContext), currentValue = _b.currentValue, onChange = _b.onChange;
    var _c = react_1.useContext(ChildrenPositionContext), first = _c.first, last = _c.last;
    var isActive = currentValue === value;
    return (react_1.default.createElement(Box_1.Box.Button, { background: isActive ? '$indigo' : '$white', borderLeftRadius: first ? '$2px' : '$none', borderRightRadius: last ? '$2px' : '$none', center: true, onClick: function () { return onChange(value); }, shadow: '$navbar', spaceHorz: '$8px', spaceVert: '$4px' },
        react_1.default.createElement(typography_1.Text, { color: isActive ? '$white' : '$grey6', size: '$12px', weight: 'medium' }, children)));
}
SegmentControl.Item = SegmentItem;
